import React from "react";
import { observer } from "mobx-react-lite";
import { List, Space, Tag, Typography } from "antd";
import WorkbenchWidgetCard from "./WorkbenchWidgetCard";
import { useWorkbenchStore } from "../stores/context";
import AlphaIdLabel from "../../tasks/components/AlphaIdLabel";
import { useTasksStore } from "../../tasks/stores/context";

const TasksWidget: React.FC = () => {
    const { workbenchStore } = useWorkbenchStore();
    const { tasksRootStore } = useTasksStore();

    const renderTasksContent = () => {
        if (!workbenchStore.tasksData.length) {
            return <div>No tasks found</div>;
        }

        return (
            <List
                size="small"
                dataSource={workbenchStore.tasksData}
                renderItem={(task) => (
                    <List.Item
                        extra={
                            <Tag color="blue">{task.status || "Unknown"}</Tag>
                        }
                    >
                        <List.Item.Meta
                            title={
                                <Space>
                                    {task.alphaId ? (
                                        <AlphaIdLabel alphaId={task.alphaId} />
                                    ) : null}
                                    <Typography.Link
                                        href={`${window.location.origin}/tasks/${task.id}`}
                                        target="_blank"
                                    >
                                        {task.title}
                                    </Typography.Link>
                                </Space>
                            }
                            description={
                                <>
                                    {workbenchStore.projects.find(
                                        (project) =>
                                            project.id === task.projectId,
                                    )?.name || "Unknown Project"}
                                    {" • "}
                                    {(task.assignee &&
                                        tasksRootStore.allUsersFullNameResolver[
                                            task.assignee
                                        ]) ||
                                        "Unassigned"}
                                </>
                            }
                        />
                    </List.Item>
                )}
            />
        );
    };

    return (
        <WorkbenchWidgetCard
            title="Tasks"
            widgetState={workbenchStore.tasksWidget}
        >
            {renderTasksContent()}
        </WorkbenchWidgetCard>
    );
};

export default observer(TasksWidget);
